import { render } from "./affiliateListing.vue?vue&type=template&id=d4224800"
import script from "./affiliateListing.vue?vue&type=script&lang=js"
export * from "./affiliateListing.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__